// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Restaurant Owner Management',
    path: '/dashboard/restro',
    icon: icon('ic_user'),
  },
  {
    title: 'Price Management',
    path: '/dashboard/price',
    icon: icon('ic_user'),
  },
  // {
  //   title: 'Payment Management',
  //   path: '/dashboard/payment',
  //   icon: icon('ic_user'),
  // }
];

export default navConfig;
